import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { selectAdvertisersData, selectSelectedAdvertiser } from '@/store/selectors/advertisers.selectors';
import {
  clearSelectedAdvertiser,
  getAdvertiserCategories,
  getAdvertisers,
  resetAdvertisersPageState,
  resetSortAndPagination,
} from '@/store/slices/advertisers.slice';
import { getClients, getWhitelabels } from '@/store/slices/sharedApi.slice';
import { Card } from '@mui/material';
import { useCallback, useEffect, useMemo, useState } from 'react';
import AdvertiserModal from './AdvertiserModal';
import AdvertisersGrid from './AdvertisersGrid';

const Advertisers = () => {
  const dispatch = useAppDispatch();

  const { data, loading: dataLoading, filters, total } = useAppSelector(selectAdvertisersData);

  const [openModal, setOpenModal] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const isLoading = useMemo(() => dataLoading || loading, [dataLoading, loading]);

  const selectedAdvertiser = useAppSelector(selectSelectedAdvertiser);

  useEffect(() => {
    dispatch(getClients());
    dispatch(getWhitelabels());
    dispatch(getAdvertiserCategories());

    return () => {
      dispatch(resetAdvertisersPageState());
    };
  }, [dispatch]);

  useEffect(() => {
    dispatch(getAdvertisers());
  }, [dispatch, filters]);

  useEffect(() => {
    if (selectedAdvertiser) {
      setOpenModal(true);
    }
  }, [selectedAdvertiser, setOpenModal]);

  const handleCloseModal = useCallback(
    (refresh?: boolean) => {
      if (refresh) {
        dispatch(resetSortAndPagination());
      }
      dispatch(clearSelectedAdvertiser());
      setOpenModal(false);
    },
    [dispatch, setOpenModal],
  );

  return (
    <div className='w-full p-[30px]'>
      <Card className='h-full'>
        <AdvertisersGrid
          data={data}
          loading={isLoading}
          rowCount={total}
          handleCreationModalOpen={() => setOpenModal(true)}
        />
        <AdvertiserModal
          open={openModal}
          onClose={handleCloseModal}
          selectedAdvertiser={selectedAdvertiser}
          loading={isLoading}
          setLoading={setLoading}
        />
      </Card>
    </div>
  );
};

export default Advertisers;
